<div class="container single-view" id="add-product">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/products/"
          class="inline-flex items-center text-base link link-icon left-arrow">
          {{ 'PRODUCTS.BTN_BACK_TO_PRODUCT' | translate }}
        </a>
      </div>
    </div>

    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-product-title" class="section-title">{{ 'PRODUCT_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-product-subtitle" class="section-subtitle mt-1 text-base">{{ 'PRODUCT_CREATE.SUBTITLE' |
          translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>

      <hr role="presentation" class="w-full mb-3 mt-6 border-t">

      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <form class="mt-0" [formGroup]="productForm" data-testid="add-product-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="add-product-details" class="border-b pb-3">
                    {{ 'PRODUCT_CREATE.PRODUCT_DETAILS' | translate }}
                  </h2>
                </div>

                @if (!hasOnlyOneActiveBrand) {
                  <div [ngClass]="{'disabled': hasOnlyOneActiveBrand }" class="field-wr flex flex-col col-12 col-sm-12 col-md-3 col-lg-6 col-xl-3">
                    <label data-testid="add-product-field-brand" class="block text-sm" for="brandId">
                      {{ 'PRODUCT_CREATE.BRAND' | translate }}
                    </label>
                    <app-custom-dropdown
                      data-testid="productbrand"
                      [placeholder]="'PRODUCT_CREATE.SELECT_BRAND' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="!hasOnlyOneActiveBrand"
                      [searchMode]="'remote'"
                      [pageSize]="combosData['brands'].rowsPerPageOption || 5"
                      [totalCount]="combosData['brands'].totalRecords"
                      [totalPages]="getComboTotalPages('brands')"
                      [options]="combosData['brands'].list"
                      formControlName="brandId"
                      (onLazyLoad)="onLazyLoadComboData('brands', $event)">
                    </app-custom-dropdown>
                  </div>
                }

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <label data-testid="add-product-field-name" class="block text-sm" for="name">
                    {{ 'PRODUCT_CREATE.PRODUCT_NAME' | translate }} <i class="icon-required-field"></i>
                  </label>
                  <input data-testid="add-product-name-input" type="text" id="name" formControlName="name"
                    autocomplete="off">
                  @if (productForm.get('name')?.invalid && productForm.get('name')?.touched) {
                    <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate
                    }}</small>
                  }
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                  <label data-testid="add-product-field-sku" class="block text-sm" for="sku">
                    {{ 'PRODUCT_CREATE.PRODUCT_SKU' | translate }} <i class="icon-required-field"></i>
                  </label>
                  <input data-testid="add-product-sku-input" type="text" id="sku" formControlName="sku"
                    autocomplete="off">
                  @if (productForm.get('sku')?.invalid && productForm.get('sku')?.touched) {
                    <small data-testid="sku-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-3 col-lg-6 col-xl-3">
                  <label data-testid="add-product-field-producttype" class="block text-sm" for="productTypeId">{{ 'PRODUCT_CREATE.PRODUCT_TYPE' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="producttype"
                    [placeholder]="'PRODUCT_CREATE.SELECT_PRODUCT_TYPE' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['productTypes'].rowsPerPageOption || 5"
                    [totalCount]="combosData['productTypes'].totalRecords"
                    [totalPages]="getComboTotalPages('productTypes')"
                    [options]="combosData['productTypes'].list"
                    formControlName="productTypeId"
                    (onLazyLoad)="onLazyLoadComboData('productTypes', $event)">
                  </app-custom-dropdown>
                  @if (productForm.get('productTypeId')?.invalid && productForm.get('productTypeId')?.touched) {
                    <small data-testid="producttype-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-3 col-lg-6 col-xl-3">
                  <label data-testid="add-product-field-productcollections" class="block text-sm" for="collections">{{ 'PRODUCT_CREATE.PRODUCT_COLLECTION' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="productcollections"
                    [placeholder]="'PRODUCT_UPDATE.SELECT_COLLECTION_PLACEHOLDER' | translate"
                    [fieldLabel]="'PRODUCT_CREATE.PRODUCT_COLLECTION' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="true"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['collections'].rowsPerPageOption || 5"
                    [totalCount]="combosData['collections'].totalRecords"
                    [totalPages]="getComboTotalPages('collections')"
                    [options]="combosData['collections'].list"
                    formControlName="collections"
                    (onLazyLoad)="onLazyLoadComboData('collections', $event)">
                  </app-custom-dropdown>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-3 col-lg-6 col-xl-3">
                  <label data-testid="add-product-field-productcategories" class="block text-sm" for="categories">{{ 'PRODUCT_CREATE.PRODUCT_CATEGORY' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="productcategories"
                    [placeholder]="'PRODUCT_UPDATE.SELECT_CATEGORY_PLACEHOLDER' | translate"
                    [fieldLabel]="'PRODUCT_CREATE.PRODUCT_CATEGORY' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="true"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['categories'].rowsPerPageOption || 5"
                    [totalCount]="combosData['categories'].totalRecords"
                    [totalPages]="getComboTotalPages('categories')"
                    [options]="combosData['categories'].list"
                    formControlName="categories"
                    (onLazyLoad)="onLazyLoadComboData('categories', $event)">
                  </app-custom-dropdown>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                  <label data-testid="add-product-field-warrantyduration" class="block text-sm"
                    for="warrantyDurationMonths">
                    {{ 'PRODUCT_CREATE.WARRANTY_DURATION' | translate }} <i class="icon-required-field"></i>
                  </label>
                  <input data-testid="add-product-warrantyduration-input" type="text" id="warrantyDurationMonths"
                    formControlName="warrantyDurationMonths" autocomplete="off">
                  @if (productForm.get('warrantyDurationMonths')?.invalid && productForm.get('warrantyDurationMonths')?.touched) {
                    <small data-testid="warrantyduration-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' |
                    translate }}</small>
                  }
                </div>

                @if (canViewPrice) {
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                    <label data-testid="add-product-field-price" class="block text-sm" for="price">
                      {{ 'PRODUCT_CREATE.PRICE' | translate }}
                    </label>
                    <input data-testid="add-product-price-input" type="text" id="price" formControlName="price"
                      autocomplete="off">
                  </div>
                }

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <label data-testid="add-product-field-description" class="block text-sm" for="description">
                    {{ 'PRODUCT_CREATE.SHORT_DESCRIPTION' | translate }} <i class="icon-required-field"></i>
                  </label>
                  <input data-testid="add-product-description-input" type="text" id="description"
                    formControlName="description" autocomplete="off">
                  @if (productForm.get('description')?.invalid && productForm.get('description')?.touched) {
                    <small data-testid="description-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate
                    }}</small>
                  }
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <label data-testid="add-product-field-imageurl" class="block text-sm" for="imageUrl">
                    {{ 'PRODUCT_CREATE.THUMBNAIL' | translate }}
                  </label>
                  <input data-testid="add-product-imageurl-input" type="text" id="imageUrl" formControlName="imageUrl"
                    autocomplete="off">
                </div>

                <!-- Dynamic product attributes -->
                @if (productAttributesFeatureEnabled && productAttributeDefinitions.length) {
                  <ng-container formArrayName="productAttributes">
                    @for (attribute of productAttributesArray.controls; track attribute; let i = $index) {
                      <ng-container [formGroupName]="i">
                        <!-- Type FIXED_VALUES (dropdown) -->
                        @if (isFixedValuesAttribute(attribute)) {
                          <div
                            class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <label class="block text-sm" [for]="'product-attribute-' + i">
                              {{ getAttributeLabel(productAttributeDefinitions[i]) }}
                            </label>
                            <app-custom-dropdown
                              [data-testid]="'product-attribute-' + i"
                              [placeholder]="('PRODUCT_CREATE.SELECT' | translate) + ' ' + getAttributeLabel(productAttributeDefinitions[i]).toLowerCase()"
                              optionLabel="text"
                              optionValue="id"
                              [isMultiselect]="allowMultipleValuesAttribute(attribute)"
                              [showSelectionChips]="true"
                              [showClear]="true"
                              [showSearchbox]="true"
                              [searchMode]="'local'"
                              [pageSize]="10"
                              [options]="getProductAttributeDropdownOptions(productAttributeDefinitions[i])"
                              formControlName="value">
                            </app-custom-dropdown>
                          </div>
                        }
                        <!-- Type INTEGER / DECIMAL / TEXT single -->
                        @if (!isFixedValuesAttribute(attribute) && !allowMultipleValuesAttribute(attribute)) {
                          <div
                            class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <label class="block text-sm" [for]="'product-attribute-single-' + i">
                              {{ getAttributeLabel(productAttributeDefinitions[i]) }}
                            </label>
                            @if (!isTextAttribute(attribute)) {
                              <input [id]="'product-attribute-single-' + i" type="number" [step]="isIntegerAttribute(attribute) ? '1' : '0.01'" formControlName="value" autocomplete="off">
                            }
                            @if (attribute.get('value')?.touched && attribute.get('value')?.invalid) {
                              @if (attribute.get('value')?.hasError('pattern')) {
                                <small class="p-error">{{ 'FORMS.INVALID_FORMAT' | translate }}</small>
                              }
                            }
                            @if (isTextAttribute(attribute)) {
                              <input [id]="'product-attribute-single-' + i" type="text" formControlName="value" autocomplete="off">
                            }
                          </div>
                        }
                        <!-- Type INTEGER / DECIMAL / TEXT multivalued -->
                        @if (!isFixedValuesAttribute(attribute) && allowMultipleValuesAttribute(attribute)) {
                          <ng-container formArrayName="values">
                            @for (valueControl of getNumericValuesArray(i).controls; track valueControl; let j = $index) {
                              <div
                                class="field-wr btn-field flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                <label [for]="'product-attribute-' + i + '-' + j" class="block text-sm mb-2">
                                  {{ getAttributeLabel(productAttributeDefinitions[i]) }} #{{ j + 1 }}
                                </label>
                                <div class="flex flex-col">
                                  <div class="flex gap-2">
                                    @if (!isTextAttribute(attribute)) {
                                      <input
                                        [id]="'product-attribute-' + i + '-' + j"
                                        type="number"
                                        [step]="isIntegerAttribute(attribute) ? '1' : '0.01'"
                                        [formControlName]="j"
                                        autocomplete="off">
                                    }
                                    @if (isTextAttribute(attribute)) {
                                      <input
                                        [id]="'product-attribute-' + i + '-' + j"
                                        type="text"
                                        [formControlName]="j"
                                        autocomplete="off">
                                    }
                                    @if (getNumericValuesArray(i).length > 1) {
                                      <button
                                        type="button"
                                        data-testid="remove-btn"
                                        class="btn primary-btn remove-btn"
                                        pTooltip="{{ 'PRODUCT_CREATE.BTN_REMOVE_ATTRIBUTE_VALUE' | translate }}"
                                        tooltipPosition="top"
                                        (click)="removeNumericMultiValue(i, j)">
                                        <span class="btn-label">{{ 'PRODUCT_CREATE.BTN_REMOVE_ATTRIBUTE_VALUE' | translate }}</span>
                                      </button>
                                    }
                                    @if (j === getNumericValuesArray(i).length - 1 && getNumericValuesArray(i).length < 10) {
                                      <button
                                        type="button"
                                        data-testid="add-btn"
                                        class="btn primary-btn add-btn"
                                        pTooltip="{{ 'PRODUCT_CREATE.BTN_ADD_ATTRIBUTE_VALUE' | translate }}"
                                        tooltipPosition="top"
                                        (click)="addNumericMultiValue(i)">
                                        <span class="btn-label">{{ 'PRODUCT_CREATE.BTN_ADD_ATTRIBUTE_VALUE' | translate }}</span>
                                      </button>
                                    }
                                  </div>
                                  @if (valueControl.touched && valueControl.invalid) {
                                    @if (valueControl.hasError('required')) {
                                      <small class="p-error">
                                        {{ 'FORMS.MANDATORY_FIELD' | translate }}
                                      </small>
                                    }
                                    @if (valueControl.hasError('pattern')) {
                                      <small class="p-error">
                                        {{ 'FORMS.INVALID_FORMAT' | translate }}
                                      </small>
                                    }
                                  }
                                </div>
                              </div>
                            }
                          </ng-container>
                        }
                      </ng-container>
                    }
                  </ng-container>
                }

                <div class="field-wr flex flex-col col-12">
                  <label data-testid="add-product-field-comment" class="block text-sm" for="comment">
                    {{ 'PRODUCT_CREATE.COMMENTS' | translate }}
                  </label>
                  <textarea data-testid="add-product-totalunits-comment" type="text" id="comment"
                  formControlName="comment" autocomplete="off"></textarea>
                </div>

                @if (hasCustomisation) {
                  <div
                    class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                    <div class="row">
                      <div class="col-12">
                        <span data-testid="add-product-field-customisable" class="label text-sm">{{ 'PRODUCT_CREATE.CUSTOMIZABLE' | translate }}</span>
                        <label data-testid="add-product-field-customisable-yes-label" class="inline-flex mr-6">
                          <p-radioButton data-testid="add-product-field-customisable-yes" name="isCustomisable"
                            value="true" formControlName="isCustomisable" inputId="customizable-yes" />
                          <span for="customizable-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                        </label>
                        <label data-testid="add-product-field-customisable-no-label" class="inline-flex mr-2">
                          <p-radioButton data-testid="add-product-field-customisable-no" name="isCustomisable"
                            value="false" formControlName="isCustomisable" inputId="customizable-no" />
                          <span for="customizable-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                }

                @if (hasItemsWithoutSerialNumberEnabled) {
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                    <div class="row">
                      <div class="col-12">
                        <span data-testid="edit-product-field-sn-required" class="label text-sm">{{
                        'PRODUCT_CREATE.IS_SN_REQUIRED' | translate }}</span>
                        <label data-testid="edit-product-field-sn-required-yes-label" class="inline-flex mr-6">
                          <p-radioButton data-testid="edit-product-field-sn-required-yes" name="isSerialNumberRequired"
                            value="true" formControlName="isSerialNumberRequired" inputId="sn-required-yes" />
                          <span for="sn-required-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                        </label>
                        <label data-testid="edit-product-field-sn-required-no-label" class="inline-flex mr-2">
                          <p-radioButton data-testid="edit-product-field-sn-required-no" name="isSerialNumberRequired"
                            value="false" formControlName="isSerialNumberRequired" inputId="sn-required-no" />
                          <span for="sn-required-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                }

                @if (hasLimitedEditionEnabled) {
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                    <div class="row">
                      <div class="col-12">
                        <span data-testid="add-product-field-limitededition" class="label text-sm">{{ 'PRODUCT_CREATE.LIMITED_EDITION' | translate }}</span>
                        <label data-testid="add-product-field-limitededition-yes-label" class="inline-flex mr-6">
                          <p-radioButton data-testid="add-product-field-limitededition-yes" name="isLimitedEdition"
                            value="true" formControlName="isLimitedEdition" inputId="limited-edition-yes" />
                          <span for="limited-edition-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                        </label>
                        <label data-testid="add-product-field-limitededition-no-label" class="inline-flex mr-2">
                          <p-radioButton data-testid="add-product-field-limitededition-no" name="isLimitedEdition"
                            value="false" formControlName="isLimitedEdition" inputId="limited-edition-no" />
                          <span for="limited-edition-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3" [ngClass]="{'disabled': productForm.get('isLimitedEdition')?.value == 'false'}">
                    <label data-testid="add-product-field-totalunits" class="block text-sm" for="limitedEditionSize">
                      {{ 'PRODUCT_CREATE.TOTAL_EDITION_UNITS' | translate }}
                    </label>
                    <input data-testid="add-product-totalunits-input" type="number" id="limitedEditionSize"
                      formControlName="limitedEditionSize" autocomplete="off" min="1">
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 pb-1 justify-end" [ngClass]="{'disabled': productForm.get('isLimitedEdition')?.value == 'false'}">
                    <div class="flex flex-row items-center gap-2">
                      <p-checkbox data-testid="add-product-field-generateserialnumbers" formControlName="generateLimitedEditionSerialNumbers" inputId="add-generate-limited-edition-serial-numbers" binary="true" />
                      <label for="add-generate-limited-edition-serial-numbers">{{ 'PRODUCT_CREATE.LIMITED_EDITION_PREGENERATE_SERIAL_NUMBERS' | translate }}</label>
                    </div>
                  </div>
                }
              </div>

              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-product-create-product-button" class="btn primary-btn"
                      [disabled]="productForm.invalid" (click)="submitForm()">
                      {{ 'PRODUCT_CREATE.BTN_ADD_NEW_PRODUCT' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
